<template>
  <f7-page class="rowBackgroundHomepage" :class="customPageClass">
    <b-container fluid :class="{customContainer: !noReduce}">
      <b-row>
        <b-col class="p-0">
          <div class="panel-default">
            <slot name="pageContent"></slot>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </f7-page>
</template>

<script>
import StreammindImage from './../../assets/static/images/streammind-text-seul.png'
import backButton from '@/components/common/backButton.vue'
import bgImg from '../../assets/static/images/header/essai-lg.jpg'

export default {
  name: 'PageOutline',
  components: {
    'back-button': backButton
  },
  props: {
    color: {
      default: 'var(--actionTextColor)'
    },
    colWidth: {
      default: '10'
    },
    icon: {
      default: ''
    },
    iconF7: {
      default: ''
    },
    iconFA: {
      default: ''
    },
    mandatoryIndication: {
      type: Boolean,
      default: false
    },
    noReduce: {
      type: Boolean,
      default: false
    },
    noReturn: {
      type: Boolean,
      default: false
    },
    pageClass: {
      type: String,
      default: ''
    },
    returnUrl: {
      default: 'none'
    },
    title: {
      default: 'Title'
    }
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    }
  },
  data () {
    return {
      logoStreammind: StreammindImage,
      bgImage: 'background-image: linear-gradient(rgba(255,255,255,0),rgba(255,255,255,1)),url('+ bgImg +');background-position:bottom;background-size:cover;top:84px;height:370px;',
      customPageClass: '',
      version: ''
    }
  },
  created () {
    this.customPageClass = this.pageClass
    this.$bus.$emit('change-mobile-header', {
      backLink: true,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: this.title,
      returnUrl: this.returnUrl
    })
    if (this.$engine.versionAPI) {
      this.version = 'Version ' + this.$engine.versionAPI
    }
  }
}
</script>
